"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ObjUtils_1 = require("../../Utils/ObjUtils");
var XoneGPSResulset_1 = require("./XoneGPSResulset");
var XoneGPSConnection = /** @class */ (function () {
    /**
     *
     */
    function XoneGPSConnection() {
        this.m_sentence = "Select STATUS,LATITUD,LONGITUD,ALTITUD,RUMBO,FGPS,HGPS,VELOCIDAD,SATELITES from GPS";
        var a = 1;
    }
    XoneGPSConnection.prototype.getTestResult = function () {
        return {
            hasError: false,
            data: [
                {
                    ID: 1, STATUS: 1, LATITUD: 38.886524, LONGITUD: -7.003800, ALTITUD: Math.floor(Math.random() * (1000 - 1)) + 1, RUMBO: Math.floor(Math.random() * (360 - 1)) + 1, FGPS: new Date(), HGPS: ObjUtils_1.default.SafeToHours(), VELOCIDAD: Math.floor(Math.random() * (200 - 1)) + 1, SATELITES: Math.floor(Math.random() * (8 - 1)) + 1
                }
            ]
        };
    };
    XoneGPSConnection.prototype.countAsync = function (Sentence) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) { return 10; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Este es el lugar donde hay que llenar los datos del GPS, se supone que es lo que lo devuelve asincrono
     * Alejandro debe completar esta funcion
     * @param Sentence
     * @param data
     */
    XoneGPSConnection.prototype.fetchDataAsync = function (Sentence, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getTestResult()];
            });
        });
    };
    XoneGPSConnection.prototype.executeQueryAsync = function (Sentence) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var rs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rs = new XoneGPSResulset_1.default(this, Sentence);
                        return [4 /*yield*/, rs.populate()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    XoneGPSConnection.prototype.executeUpdateAsync = function (Sentence) {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.executeNonQuery = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        hasError: false,
                        data: [{
                                result: 1
                            }]
                    }];
            });
        });
    };
    XoneGPSConnection.prototype.executeAsync = function (Sentence, MaxRows) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.executeNonQuery()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    XoneGPSConnection.prototype.executeQuery = function (Sentence) {
        return new XoneGPSResulset_1.default(this, this.m_sentence);
    };
    XoneGPSConnection.prototype.createStatement = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.isClosed = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.commit = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.beginTrans = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.rollback = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.execute = function (parameter, MaxRows) {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.executeUpdate = function (Sentence) {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.executeOperation = function (OperType, tableName, values, whereClause) {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.getDBMS = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.outerJoinsSupported = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.acceptsParsedSentences = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.acceptsEmptyQueries = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.LastRowsAffected = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.LastInsertedRowId = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.cancelProcesses = function (flags) {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.setCryptoData = function (cryptoData) {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.getCryptoData = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.cryptoSupported = function () {
        throw new Error("Method not implemented.");
    };
    XoneGPSConnection.prototype.getTokenFromAuth = function (login, pass) {
        throw new Error("Method not implemented.");
    };
    return XoneGPSConnection;
}());
exports.default = XoneGPSConnection;

//# sourceMappingURL=XoneGPSConnection.js.map
